import React, { useEffect, useState } from "react";
import { LatLngExpression } from "leaflet";
import { Checkbox, Dialog, DialogContent, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import LoacationMaps from "./location-map";
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { PropertyObj } from "../../../Models/PropertyObj";
import { GenerateDescServ, GenerateDescTitleServ, GenerateTitleServ, GetTemplateServ, SaveTemplateServ } from "../../../Services/Generate";
import PropertyDetails from "./property-details";
import Country from "./country";
import PlacesAutocomplete from "./places-autocomplete";
import SpecialAboutProperty from "./special_about_property";
import { AddListing, UploadTemplateServ } from "../../../Services/Properties";
import PrivateAmenities from "./private-amenities";
import SharedAmenities from "./shared-amenities";
import AssignTo from "./assign-to";
import DescriptionDetails from "./description-details";
import UploadTemplate, { Template } from "../../AI-Description-Title/upload-template";
import { useAppDispatch } from "../../store/store";
import { fetchHeaderData } from "../../store/headerSlice";
import GenerateDescription from "../../AI-Description-Title/generate-description";
import GenerateTitle from "../../AI-Description-Title/generate-title";
import { useTranslation } from "react-i18next";
import MediaUploadSection from "./media-upload-section";

const theme = createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#ffffff',
                    padding: "10px",
                    color: 'rgba(0, 0, 0, 0.6)',
                    boxShadow: '0px 4px 48px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Plus Jakarta Sans',
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "12px",
                    lineHeight: "13px",
                    width: "100%"
                },
                arrow: {
                    color: '#ffffff',
                },
            },
        },
    },
});

const GenerateDescTitle: React.FunctionComponent<{ onChangeTaps: any, onShowMessageUpgrade: any, onChangehandler: any }> = (props) => {

    const seo = {
        "name": "SEO optimized",
        "length": "Short and Concise",
        "tone": "Formal and Professional",
        "style": "Rustic and Charming",
        "minCharactersDesc": 1000,
        "maxCharactersDesc": 1300,
        "minCharactersTitle": 50,
        "maxCharactersTitle": 76,
        "template": "seo_optimized",
        "imagesAnalysis": true,
        "agencyIntroduction": true,
    }
    const defaultDesc = {
        name: "Default",
        length: "Detailed and Elaborate",
        tone: "Cozy and Inviting",
        style: "Modern and Sleek",
        minCharactersDesc: 1200,
        maxCharactersDesc: 1500,
        minCharactersTitle: 50,
        maxCharactersTitle: 100,
        imagesAnalysis: true,
        template: "default",
        agencyIntroduction: true,
    }
    const [langDesc, setlangDesc] = useState<any>(() => {
        const storedData = sessionStorage.getItem("property_details");
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                if (Array.isArray(parsed.lang) && parsed.lang.length > 0) {
                    return parsed.lang[0];
                }
            } catch (e) {
                console.error("Failed to parse property_details:", e);
            }
        }
        return "";
    });
    function getRandomSevenDigitNumber(): string {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        const numbers = "0123456789";

        // Generate letters
        let chars = "";
        for (let i = 0; i < 2; i++) {
            chars += letters.charAt(Math.floor(Math.random() * letters.length));
        }

        // Generate numbers
        let digits = "";
        for (let i = 0; i < 8; i++) {
            digits += numbers.charAt(Math.floor(Math.random() * numbers.length));
        }

        return `${chars}-${digits}`;
    }
    const [langTitle, setlangTitle] = useState<any>(() => {
        const storedData = sessionStorage.getItem("property_details");
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                if (Array.isArray(parsed.lang) && parsed.lang.length > 0) {
                    return parsed.lang[0];
                }
            } catch (e) {
                console.error("Failed to parse property_details:", e);
            }
        }
        return "";
    });
    const [property, setProperty] = useState<PropertyObj>(() => {
        const storedData = sessionStorage.getItem("property_details");
        return storedData ? JSON.parse(storedData) : {
            size: {
                unitBuiltUp: "Sq M",
                unitPlot: "Sq M"
            },
            idProperty: getRandomSevenDigitNumber(),
            descriptionTitle: defaultDesc,
        } as PropertyObj;
    });
    const [listImages, setListImages] = useState<any>(() => {
        const storedData = sessionStorage.getItem("listing");
        if (!storedData) return [];

        try {
            const parsed = JSON.parse(storedData);
            return parsed.images ?? [];
        } catch (e) {
            console.error("Erreur de parsing JSON:", e);
            return [];
        }
    });
    const [position, setPosition] = useState<LatLngExpression>([25.2048493, 55.2707828]);
    const [zoomValue, setZoomValue] = useState(14);
    const [isGenerate, setIsGenerate] = useState(false);
    const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
    const [templateName, setTemplateName] = useState<any>();
    const [templateSelected, setTemplateSelected] = useState<any>(defaultDesc);
    const [listTemplate, setListTemplate] = useState<any>([]);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [SizeValue, setSizeValue] = useState<any>();
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        GetTemplateServ().then((resp) => {
            const updatedList = [defaultDesc, seo, ...resp];
            setListTemplate(updatedList);
        })
    }, [isChange])


    const handleChangeProperty = (data: any) => {
        console.log(data)
        setProperty((prevOptions: any) => {
            const updatedProperty = {
                ...prevOptions,
                ...data
            };
            return updatedProperty;
        });
    }

    const handleChangeSize = (sizeValue: any) => {
        setSizeValue(sizeValue);
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            size: {
                ...prevOptions.size,
                ...sizeValue
            }
        }));
    }

    // Agent 

    const handleChangeAgent = (resp: any) => {
        if (!resp) return;
        setProperty((prevOptions: any) => {
            const updatedProperty = {
                ...prevOptions,
                agent: {
                    ...prevOptions.agent,
                    id: resp.userId,
                    email: resp.email,
                    fullName: resp.fullName,
                    phoneNumber: resp.phoneNumber,
                    languages: resp.languages,
                    image: resp.image,
                }
            };
            return updatedProperty;
        });
        console.log(property)
    }

    // Location

    const handleChangeCountry = (event: any) => {
        const country = event.target.value;
        const validLangs = getLanguageOptions(country).map((l: any) => l.value);

        setProperty((prevOptions: any) => {
            const filteredLangs = (prevOptions.lang || []).filter((l: string) => validLangs.includes(l));

            return {
                ...prevOptions,
                address: {
                    ...prevOptions.address,
                    country: event.target.value
                },
                price: {
                    currency: country === "UAE" ? "AED" : "GBP"
                },
                lang: filteredLangs
            };
        });
    }

    // Address

    const handleChangeAdress = (data: any) => {
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            address: {
                ...prevOptions.address,
                city: data.city,
                Community: data.community,
                subCommunity: data.subCommunity,
                latitude: data.lat,
                buildingName: data.building,
                longitude: data.lng,
                country: data.country,
                address: data.address
            },
        }));
        setPosition([data.lat, data.lng])
    }

    // Amenities

    const handleChangeSharedAmenities = (value: any) => {
        setProperty((prevOptions: any) => {
            const sharedAmenities = prevOptions.sharedAmenities || [];

            let updatedAmenities;
            if (sharedAmenities.includes(value)) {
                updatedAmenities = sharedAmenities.filter((selected: any) => selected !== value);
            } else {
                updatedAmenities = [...sharedAmenities, value];
            }

            return {
                ...prevOptions,
                sharedAmenities: updatedAmenities
            };
        });

    }

    const handleChangePrivateAmenities = (value: any) => {
        setProperty((prevOptions: any) => {
            const privateAmenities = prevOptions.privateAmenities || [];
            let updatedAmenities;
            if (privateAmenities.includes(value)) {
                updatedAmenities = privateAmenities.filter((selected: any) => selected !== value);
            } else {
                updatedAmenities = [...privateAmenities, value];
            }
            return {
                ...prevOptions,
                privateAmenities: updatedAmenities
            };
        });
    }

    // Description

    const handleChangeCheck = (event: any) => {
        const { name, checked } = event.target;
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                [name]: checked,
            },
        }));
    }

    const handleSelectLanguge = (event: any) => {
        const { value } = event.target;

        const selectedLangs = typeof value === 'string'
            ? value.split(',')
            : (value as string[]);

        setProperty((prevOptions) => ({
            ...prevOptions,
            lang: selectedLangs,
        }));

        const firstLang = selectedLangs.length > 0 ? selectedLangs[0] : "";
        setlangDesc(firstLang);
        setlangTitle(firstLang);
    }

    const handleChangeDescTitle = (event: any) => {
        const { name, value } = event.target;
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                [name]: value,
            },
        }));
    }

    //Generate 
    const validateForm = () => {
        const newErrors: { [key: string]: boolean } = {};

        if (!property.address?.country) newErrors.country = true;
        if (!property.address?.address) newErrors.address = true;
        if (!property.offeringType) newErrors.offeringType = true;
        if (!property.category) newErrors.category = true;
        if (!property.propertyType) newErrors.propertyType = true;

        if (!property.descriptionTitle?.length) newErrors.desclength = true;
        if (!property.descriptionTitle?.style) newErrors.style = true;
        if (!property.descriptionTitle?.tone) newErrors.tone = true;

        if (!property.privateAmenities || property.privateAmenities.length === 0)
            newErrors.privateAmenities = true;

        if (!property.lang || property.lang.length === 0) newErrors.lang = true;
        if (!property.furnishingType) newErrors.furnishingType = true;

        if (property.category === "residential") {
            if (property.bedroom === undefined || property.bedroom === null)
                newErrors.bedroom = true;

            if (property.bathroom === undefined || property.bathroom === null)
                newErrors.bathroom = true;
        }

        if (!property.price?.amount) newErrors.amount = true;
        if (!property.price?.currency) newErrors.currency = true;

        if (!SizeValue.plotSize) newErrors.plotSize = true;
        if (!SizeValue.builtUpSize) newErrors.builtUpSize = true;
        if (!property.idProperty) newErrors.idProperty = true;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const isFormValid = () => {
        // Only valid if property.description and property.title are not empty,
        // property.agent?.fullName exists, and listImages.length > 0
        return (
            Array.isArray(property.description) && property.description.length > 0 &&
            Array.isArray(property.title) && property.title.length > 0 &&
            property.agent?.fullName &&
            listImages.length > 0
        );
    };


    const handleGenerateDesc = () => {
        return new Promise((resolve, reject) => {
            GenerateDescServ(sessionStorage.getItem("processid"), property, langDesc)
                .then((resp) => {
                    const result = resp.data.result?.trim();
                    if (result) {
                        setProperty((prevOptions: any) => {
                            const updatedDesc = prevOptions.description.map((item: any) =>
                                item.lang === langDesc ? { ...item, desc: result } : item
                            );
                            const updatedProperty = {
                                ...prevOptions,
                                description: updatedDesc
                            };
                            sessionStorage.setItem("property_details", JSON.stringify(updatedProperty));

                            return updatedProperty;
                        });

                        props.onChangehandler("Description Generated Successfully!", true, "success");
                    } else {
                        props.onChangehandler("Failed to generate description. Please try again.", true, "error");
                    }
                    resolve(resp);
                })
                .catch((error) => {
                    reject(error);
                    if (error.response.status === 401) {
                        props.onShowMessageUpgrade(error.response.data.message);
                    } else {
                        props.onChangehandler("Failed to generate description. Please try again.", true, "error");
                    }
                });
        })
    }

    const handleGenerateTitle = () => {
        return new Promise((resolve, reject) => {
            GenerateTitleServ(sessionStorage.getItem("processid"), property, langTitle).then((resp) => {
                const result = resp.data.result?.trim();

                if (result) {
                    setProperty((prevOptions: any) => {
                        const updatedDesc = prevOptions.title.map((item: any) =>
                            item.lang === langTitle ? { ...item, title: result } : item
                        );
                        const updatedProperty = {
                            ...prevOptions,
                            title: updatedDesc
                        };

                        sessionStorage.setItem("property_details", JSON.stringify(updatedProperty));

                        return updatedProperty;
                    });
                    props.onChangehandler("Title Generated Successfully!", true, "success");
                } else {
                    props.onChangehandler("Failed to generate title. Please try again.", true, "error");
                }
                resolve(resp)
            }).catch((error) => {
                reject(error)
                if (error.response.status === 401) {
                    props.onShowMessageUpgrade(error.response.data.message);
                } else {
                    props.onChangehandler("Failed to generate title. Please try again.", true, "error");
                }
            })
        })
    }

    const Generate = () => {

        setIsGenerate(true)
        const isValid = validateForm();
        setProperty((prevOptions: any) => {
            const updatedProperty = {
                ...prevOptions,
                description: {},
                title: {},
                size: SizeValue
            };
            return updatedProperty
        });

        if (isValid) {
            GenerateDescTitleServ("", {
                ...property,
                description: {},
                title: {},
                size: SizeValue
            }).then((resp) => {
                setIsGenerate(false)
                if (resp && Array.isArray(resp.desc) && Array.isArray(resp.title) && resp.desc.length > 0 && resp.title.length > 0) {
                    setProperty((prevOptions: any) => {
                        const updatedProperty = {
                            ...prevOptions,
                            description: resp.desc,
                            title: resp.title,
                        };
                        sessionStorage.setItem("property_details", JSON.stringify(updatedProperty));
                        return updatedProperty;
                    });

                    props.onChangehandler("Description and Title Generated Successfully!", true, "success");
                } else {
                    props.onChangehandler("Failed to generate description and title. Please try again.", true, "error");
                }

            }).catch((error: any) => {
                setIsGenerate(false)
                if (error.response.status === 401) {
                    props.onShowMessageUpgrade(error.response.data.message);
                } else {
                    props.onChangehandler("Failed to generate description and title. Please try again.", true, "error");
                }
            })
        } else {
            setIsGenerate(false)
            props.onChangehandler("Please review the form. Some required fields are missing or incorrectly filled.", true, "error");
        }
    }

    //Edit

    const handleEditDesc = (event: any) => {
        const newValue = event.target.value;
        setProperty((prevProperty: any) => ({
            ...prevProperty,
            description: prevProperty.description.map((item: any) =>
                item.lang === langDesc ? { ...item, desc: newValue } : item
            )
        }));
    }

    const handleEditTitle = (event: any) => {
        const newValue = event.target.value;
        setProperty((prevProperty: any) => ({
            ...prevProperty,
            title: prevProperty.title.map((item: any) =>
                item.lang === langTitle ? { ...item, title: newValue } : item
            )
        }));
    }

    const ChangeLangDesc = (lang: any) => {
        setlangDesc(lang)
    }

    const ChangeLangTitle = (lang: any) => {
        setlangTitle(lang)
    }

    //Template

    const handleChangeTemplate = (event: any) => {
        setTemplateName(event.target.value)
    }

    const SaveTemplate = () => {
        setIsOpen(false)
        const obj = {
            "length": property.descriptionTitle?.length,
            "tone": property.descriptionTitle?.tone,
            "style": property.descriptionTitle?.style,
            "imagesAnalysis": property.descriptionTitle?.imagesAnalysis,
            "agencyIntroduction": property.descriptionTitle?.agencyIntroduction,
            "name": templateName
        }
        SaveTemplateServ(obj).then((resp) => {
            setIsChange(!isChange)
            props.onChangehandler("Template saved successfully.", true, "success")
        }).catch((error) => {
            props.onChangehandler(error.response.data.error, true, "error")
        })
    }

    const handleSelectTemplate = (event: any) => {
        const template = event.target.value;
        setTemplateSelected(template)
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                agencyIntroduction: template.agencyIntroduction,
                imagesAnalysis: template.imagesAnalysis,
                length: template.length,
                template: template.name,
                name: template.name,
                style: template.style,
                tone: template.tone
            },
        }));
    }

    // Change lang

    const getDescriptionByLang = (lang: string) => {
        const descList = property?.description;
        if (!Array.isArray(descList)) return "";
        const found = descList.find((item) => item.lang === lang);
        return found ? found.desc : "";
    }

    const getTitleByLang = (lang: string) => {
        const titleList = property?.title;
        if (!Array.isArray(titleList)) return "";
        const found = titleList.find((item) => item.lang === lang);
        return found ? found.title : "";
    }

    // Define language options based on country
    const getLanguageOptions = (country: any) => {
        const languageConfig: any = {
            "UAE": [
                { value: "arabic", label: "Arabic" },
                { value: "english", label: "English" },
                { value: "french", label: "French" },
                { value: "spanish", label: "Spanish" }
            ],
            "ME": [
                { value: "english", label: "English" },
                { value: "german", label: "German" },
                { value: "serbian", label: "Serbian" },
                { value: "polish", label: "Polish" },
                { value: "russian", label: "Russian" }
            ],
            "default": [
                { value: "english", label: "English" },
                { value: "french", label: "French" },
                { value: "spanish", label: "Spanish" }
            ]
        };

        // Return the country-specific options or default if not found
        return languageConfig[country] || languageConfig["default"];
    };

    const handleChangeMessage = (color: string, msg: string) => {
        props.onChangehandler(msg, true, color);
    }

    
    const UploadTemplateHandler = async (template: Template): Promise<void> => {

        UploadTemplateServ(template).then((resp) => {
            props.onChangehandler("Template uploaded successfully", true, "success")
            setIsChange(!isChange)
            setProperty((prevOptions: any) => ({
                ...prevOptions,
                descriptionTitle: {
                    ...prevOptions.descriptionTitle,
                    template: template.name
                },
            }));
            setTemplateSelected(template.name)
        }).catch((error) => {
            props.onChangehandler("Failed to Upload Template.", true, "error")
        })
    }

    //Copy Text

    const handleCopyText = (textToCopy: any) => {
        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    props.onChangehandler("Copied successfully!", true, "success");
                })
                .catch((err) => {
                    props.onChangehandler("Failed to copy. Please try again.", true, "error");
                });
        }
    }
    
    const CreateProperty = () => {
        const obj = {
            "processid": sessionStorage.getItem("processid"),
            "property": property,
            "portals": [],
            "publish": true
        }
        AddListing(obj).then((resp) => {
            sessionStorage.setItem('propertyId', resp.listing._id)
            props.onChangehandler("Listing created successfully", true, "success")
            props.onChangeTaps("MarketingAssests");
            setTimeout(() => {
                dispatch(fetchHeaderData());
            }, 2000)

        }).catch((error) => {
            if (error.response.status === 401) {
                props.onShowMessageUpgrade(error.response.data.message);
            } else {
                props.onChangehandler("Failed to Create Property.", true, "error")
            }
        })
    }


    return (
        <>
            <div className="row">
                <div className="col-1 mt-4">
                    <button className="buuton-next border-trans marg-right-10 marg-right-16 back-EEF2FF border-9" onClick={() => props.onChangeTaps("Photos")}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="col-11 justify-content-center mt-4">
                    <div className="header-title">
                        <h1 className="title-24 title-20-mb mb-3 text-center">{t("generateDescTitle.headerTitle")}</h1>
                        <p className="para-16 color-39393B text-center">{t("generateDescTitle.headerSubtitle")}</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="card border-20 mb-4" >
                        <div className="card-body padd-24">
                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.location")}
                            </h3>

                            <div className="row card-form mb-4">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("generateDescTitle.country")} *</label>
                                    <FormControl fullWidth>
                                        <Select
                                            className={`input-property mb-3 ${errors.country ? 'input-error' : ''}`}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Select' }}
                                            value={property.address?.country || ''}
                                            name="country"
                                            onChange={handleChangeCountry}
                                        >
                                            <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                                            <MenuItem value={"UK"}>{t("generateDescTitle.uk")}</MenuItem>
                                            <MenuItem value={"UAE"}>{t("generateDescTitle.uae")}</MenuItem>
                                            <MenuItem value={"ME"}>{t("generateDescTitle.me")}</MenuItem>
                                            <MenuItem value={"FR"}>{t("generateDescTitle.fr")}</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <PlacesAutocomplete property={property} errors={errors} onChangeAdress={handleChangeAdress} />
                                </div>
                                <div className="col-md-8 mb-3">
                                    <LoacationMaps position={position} zoomValue={zoomValue} address={property.address} height={400} />
                                </div>
                            </div>

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.propertyDetails")}
                            </h3>

                            <PropertyDetails property={property} errors={errors} onchangeProperty={handleChangeProperty} onchangeSize={handleChangeSize} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.countrySection")}
                                <ThemeProvider theme={theme}>
                                    <Tooltip title={t("generateDescTitle.countryTooltip")} arrow placement="right">
                                        < button className="border-trans back-trans" > <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_528_412)">
                                                <path d="M2.66699 8C2.66699 8.78793 2.82219 9.56815 3.12371 10.2961C3.42524 11.0241 3.8672 11.6855 4.42435 12.2426C4.9815 12.7998 5.64294 13.2417 6.37089 13.5433C7.09885 13.8448 7.87906 14 8.66699 14C9.45492 14 10.2351 13.8448 10.9631 13.5433C11.691 13.2417 12.3525 12.7998 12.9096 12.2426C13.4668 11.6855 13.9087 11.0241 14.2103 10.2961C14.5118 9.56815 14.667 8.78793 14.667 8C14.667 6.4087 14.0349 4.88258 12.9096 3.75736C11.7844 2.63214 10.2583 2 8.66699 2C7.07569 2 5.54957 2.63214 4.42435 3.75736C3.29913 4.88258 2.66699 6.4087 2.66699 8Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.66699 6H8.67283" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8 8H8.66667V10.6667H9.33333" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_528_412">
                                                    <rect width="16" height="16" fill="white" transform="translate(0.666992)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        </button>
                                    </Tooltip>
                                </ThemeProvider>
                            </h3>

                            <Country property={property} errors={errors} onchangeProperty={handleChangeProperty} country={property.address?.country || "UK"} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.privateAmenities")} *
                            </h3>

                            <PrivateAmenities property={property} errors={errors} onchangePrivateAmenities={handleChangePrivateAmenities} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.sharedAmenities")}
                            </h3>

                            <SharedAmenities property={property} onchangeSharedAmenities={handleChangeSharedAmenities} />

                            <SpecialAboutProperty property={property} onchangeProperty={handleChangeProperty} />

                            <div className="row d-flex justify-content-between mb-2 align-items-center">
                                <div className="col-md-6">
                                    <h3 className="title-20 title-18-mb color-black mb-0">
                                        {t("generateDescTitle.descriptionAndTitle")}
                                    </h3>
                                </div>
                                <div className="col-md-6 d-flex-end mb-4">
                                    <UploadTemplate onUploadTemplate={UploadTemplateHandler} />

                                    <FormControl fullWidth className="max-width-25">
                                        <InputLabel id="demo-simple-select-label" sx={{
                                            color: "#6366F1 !important",
                                            fontWeight: "700",
                                            background: "#ffffff"
                                        }}>{t("generateDescTitle.templates")}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Templates"
                                            className="button-reset"
                                            inputProps={{ 'aria-label': 'Templates' }}
                                            value={templateSelected || ''}
                                            onChange={handleSelectTemplate}
                                            displayEmpty
                                            renderValue={(selected) =>
                                                selected ? selected.name : "Templates"
                                            }
                                            sx={{
                                                "& .MuiSelect-select": {
                                                    border: "1px solid #6366F1 !important",
                                                    color: "#6366F1 !important",
                                                    fontWeight: 500,
                                                    borderRadius: "10px !important",
                                                    height: "44px !important",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textAlign: "center",
                                                    padding: "0px 16px 0px !important",
                                                }
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {t("generateDescTitle.templates")}
                                            </MenuItem>
                                            {listTemplate && listTemplate.map((template: any, index: any) => (
                                                <MenuItem key={index} value={template}>{template.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="row card-form mb-4">

                                <DescriptionDetails property={property} errors={errors} onChangeDesc={handleChangeDescTitle} />

                                <div className="div-flex-center mt-1 ">
                                    <div className="form-check col-12 col-md-auto mb-4 marg-right-16">
                                        <input className="form-check-input" type="checkbox" onChange={handleChangeCheck} name="agencyIntroduction" checked={property.descriptionTitle?.agencyIntroduction ? property.descriptionTitle.agencyIntroduction : ""} />
                                        <label className="form-check-label" htmlFor="defaultCheck2" style={{ cursor: "pointer" }}>
                                            {t("generateDescTitle.addAgencyIntro")}
                                        </label>
                                    </div>
                                    <div className="form-check col-12 col-md-auto mb-4 marg-right-16">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={handleChangeCheck}
                                            id="includeAnalysis"
                                            name="imagesAnalysis"
                                            checked={property.descriptionTitle?.imagesAnalysis ? property.descriptionTitle.imagesAnalysis : ""}
                                        />
                                        <label className="form-check-label" htmlFor="includeAnalysis">
                                            {t("generateDescTitle.includeImageAnalysis")}
                                        </label>
                                    </div>
                                    <div className="col-12 col-md-auto mb-4 marg-right-16">
                                        <FormControl className="width-180">
                                            <Select
                                                labelId="demo-multiple-checkbox-label"
                                                multiple
                                                displayEmpty
                                                className={`input-property ${errors.lang ? 'input-error' : ''}`}
                                                value={property.lang ?? []}
                                                inputProps={{ 'aria-label': 'Select Languages' }}
                                                onChange={handleSelectLanguge}
                                                renderValue={(selected) => {
                                                    if (!selected || selected.length === 0) {
                                                        return <span style={{ color: "#A0AEC0" }}>Select languages</span>;
                                                    }
                                                    return selected.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ');
                                                }}
                                            >
                                                <MenuItem disabled value="">
                                                    <span style={{ color: "#A0AEC0" }}>Select languages</span>
                                                </MenuItem>
                                                {getLanguageOptions(property?.address?.country).map((lang: any) => (
                                                    <MenuItem key={lang.value} value={lang.value}>
                                                        <Checkbox checked={property.lang?.includes(lang.value) ?? false} />
                                                        <ListItemText primary={lang.label} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="mb-4 marg-left-auto">
                                        <button className="button-reset back-E0E7FF color-746AFF border-trans padd-15 width-max-content" onClick={() => { setIsOpen(true); setTemplateName("") }}>
                                            {t("generateDescTitle.saveParameters")}
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <div className="d-flex justify-content-center mb-4">
                                <button type="submit" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30`} onClick={Generate}>
                                    {t("generateDescTitle.generate")} {isGenerate && <div className="spinner-border text-white size-20" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                                </button>
                            </div>

                            <h3 className="title-20 title-18-mb color-black mb-4 mt-4">
                                {t("generateDescTitle.description")}
                            </h3>

                            <GenerateDescription descValue={getDescriptionByLang(langDesc)} languages={property.lang} langDesc={langDesc} onCopyText={handleCopyText} onEditDesc={handleEditDesc} onGenerateDesc={handleGenerateDesc} onChangeLang={ChangeLangDesc} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.title")}
                            </h3>

                            <GenerateTitle titleValue={getTitleByLang(langTitle)} languages={property.lang} langTitle={langTitle} onCopyText={handleCopyText} onEditTitle={handleEditTitle} onGenerateTitle={handleGenerateTitle} onChangeLang={ChangeLangTitle} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                Media
                            </h3>

                            <MediaUploadSection property={property} onchangeProperty={handleChangeProperty} />

                            <AssignTo property={property} onchangeAgent={handleChangeAgent} onChangeMessagehandler={handleChangeMessage} />

                         </div>
                    </div>

                    <div className="d-flex justify-content-end marg-top-60">
                        <button type="submit" className="button-dash back-EEF2FF z-index-1 color-475569 border-trans padd-15-30 padd-5-15-mb width-auto marg-right-16" onClick={() => props.onChangeTaps("Photos")}>
                            <svg width="24" height="24" className="marg-right-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_85_1292)">
                                    <path d="M19 12H5" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11 18L5 12" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11 6L5 12" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_85_1292">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {t("generateDescTitle.previous")}
                        </button>

                        <button type="submit" className={`button-dash back-EEF2FF z-index-1 color-746AFF border-746AFF  padd-15-30 padd-5-15-mb width-auto marg-right-16 ${isFormValid()? "" : "disabled"}`} onClick={CreateProperty}>
                            {t("generateDescTitle.finishAndPreview")} <svg width="25" height="24" className="marg-left-10" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_118_150)">
                                    <path d="M5.5 12H19.5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M13.5 18L19.5 12" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M13.5 6L19.5 12" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_118_150">
                                        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>

                </div>
            </div>

            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogTitle >
                    <div className="para-16 bold-600 ">{t("generateDescTitle.template")}</div>
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <label className="form-label font-16 mb-3" htmlFor="selectTypeOpt">{t("generateDescTitle.templateName")}</label>
                    <input type="text" className="form-input border-E6E6E6" placeholder={t("generateDescTitle.enterTemplateName")} value={templateName || ''} onChange={handleChangeTemplate} />
                    <div className="mt-4 d-flex justify-content-center">
                        <button type="button" onClick={SaveTemplate} className={`button-dash back-746AFF color-FFFFFF  padd-10-30 border-746AFF marg-right-16 ${templateName ? "" : "disabled"}`} data-bs-dismiss="modal">{t("propertiesPage.save")}</button>
                    </div>
                </DialogContent>

            </Dialog>

        </>
    )
}
export default GenerateDescTitle;
